import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

import TkPopProductDetailCommonDialog from "../dialogTypes/TkPopProductDetailCommonDialog";

function TkPopProductManageDetailCommonCreate(props) {

    const { t } = useTranslation();

    const { id, schema, refresh, onSuccess, onSelectMst, detailSeletMst, createButtonName, customizeErrorMsgCallback, ...others } = props;
    const [open, setOpen] = useState(false);

    // const [processName, setProcessName] = useState();

    // useEffect(() => {

    //     let processName = id;

    //     switch (id) {
    //         case "Edm":
    //             processName = "Nc"
    //             break;
    //         default:
    //             processName = id
    //             break;
    //     }

    //     if (id) {
    //         setProcessName(processName)
    //     }

    // }, [id])

    const onOpen = () => {

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };


    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={id + "Create"} {...others} />
            <TkPopProductDetailCommonDialog
                id={id + "create-dialog"}
                mode="update"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${id}.create`) : ""}
                schema={schema}
                initialData={undefined}
                open={open}
                processCode={onSelectMst?.processCode}
                onClose={onClose}
                onSelectMst={onSelectMst}
                detailSeletMst={detailSeletMst}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkPopProductManageDetailCommonCreate;

